module.exports = __webpack_public_path__ + "static/media/Logo_SFLC.c3e37fc6.jpg";